/*
  Alternativen in derselben Grösse — füllt snippets/vantiq-alternativen.liquid.

  Ablauf
    1. Nach dem Seitenaufbau laden, im Leerlauf des Browsers (Begründung
       unten bei `starten`).
    2. Alle Seiten von `search?view=vantiq-alternativen` holen.
    3. Die Regel anwenden: gleiche Grösse, Saison, Lastindex und
       Geschwindigkeitsindex, bestellbar, mit VANTIQ-Index. Grösse und Saison
       prüft das Skript noch einmal, obwohl die Suche danach gefiltert hat —
       die Tags sind gepflegt, die Metafelder sind die Quelle.
    4. Drei Karten mit Rolle, der Rest hinter einer Kachel, die im Block
       aufklappt. Ein Link auf die Suche ginge nicht: Last- und
       Geschwindigkeitsindex sind keine Tags, die Suche zeigte also auch die
       Reifen, die die Regel ausschliesst.

  Die Rollen sind aus Preis und Index abgeleitet, kein Urteil. Eine Rolle wird
  nur vergeben, wenn sie stimmt: „Höchster Index in dieser Grösse" nur, wenn
  der Reifen den angezeigten übertrifft; „Günstigster mit Bewertung" nur, wenn
  er billiger ist.
*/
(function () {
  'use strict';

  var MAX_SEITEN = 8;
  var SICHTBAR_BREIT = 3;
  var SICHTBAR_SCHMAL = 2;

  function zahl(wert) {
    if (wert === null || wert === undefined || wert === '') return null;
    var n = Number(wert);
    return isFinite(n) ? n : null;
  }

  function text(wert) {
    return wert === null || wert === undefined ? '' : String(wert).trim();
  }

  function schluessel(wert) {
    var n = zahl(wert);
    return n === null ? '' : String(n);
  }

  // Wie assets/vantiq-product-detail-v2.js: zwei Stellen, Apostroph als Tausendertrenner.
  function betrag(rappen) {
    var teile = (Math.abs(Number(rappen) || 0) / 100).toFixed(2).split('.');
    teile[0] = teile[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    return teile.join('.');
  }

  function geld(format, rappen) {
    return String(format || 'CHF {{ amount }}').replace(/\{\{\s*amount[^}]*\}\}/, betrag(rappen));
  }

  function differenz(n, formatiert) {
    if (n < 0) return '−' + formatiert;
    if (n > 0) return '+' + formatiert;
    return '±' + formatiert;
  }

  function saisonCode(roh) {
    var s = text(roh).toLowerCase();
    if (!s) return '';
    if (s.indexOf('ommer') !== -1) return 'summer';
    if (s.indexOf('inter') !== -1) return 'winter';
    return 'allseason';
  }

  // tire-model-name fällt ohne Modell-Metafeld auf den Titel zurück, und der
  // trägt „– 225/40/18 92W XL" am Ende. Die Kennung steht auf der Karte ohnehin.
  function modellName(eintrag) {
    var name = text(eintrag.name).replace(/\s+[–—-]\s+\d{3}\/.*$/, '');
    var marke = text(eintrag.vendor);
    if (marke && name.toLowerCase().indexOf(marke.toLowerCase() + ' ') === 0) {
      name = name.slice(marke.length).trim();
    }
    return name || marke;
  }

  function kennungVon(eintrag) {
    return schluessel(eintrag.load) + text(eintrag.speed).toUpperCase() + (eintrag.xl === true ? ' XL' : '');
  }

  function element(tag, klasse, inhalt) {
    var el = document.createElement(tag);
    if (klasse) el.className = klasse;
    if (inhalt !== undefined && inhalt !== null) el.textContent = inhalt;
    return el;
  }

  function laden(wurzel, abfrage) {
    var basis = wurzel + 'search?view=vantiq-alternativen&type=product&q=' + encodeURIComponent(abfrage);

    function seite(nr) {
      return fetch(basis + (nr > 1 ? '&page=' + nr : ''), { credentials: 'same-origin' }).then(function (antwort) {
        if (!antwort.ok) throw new Error('HTTP ' + antwort.status);
        return antwort.json();
      });
    }

    return seite(1).then(function (erste) {
      var seiten = Math.min(zahl(erste.pages) || 1, MAX_SEITEN);
      var weitere = [];
      for (var nr = 2; nr <= seiten; nr += 1) weitere.push(seite(nr));
      return Promise.all(weitere).then(function (rest) {
        return rest.reduce(function (alle, s) {
          return alle.concat(s.products || []);
        }, erste.products || []);
      });
    });
  }

  function bezugLesen(wurzel) {
    var d = wurzel.dataset;
    return {
      wurzel: d.wurzel || '/',
      abfrage: d.abfrage || '',
      handle: d.handle || '',
      breite: schluessel(d.breite),
      quer: schluessel(d.quer),
      zoll: schluessel(d.zoll),
      saison: d.saison || '',
      last: schluessel(d.last),
      tempo: text(d.tempo).toUpperCase(),
      index: zahl(d.index),
      preis: zahl(d.preis),
      geldformat: d.geldformat || 'CHF {{ amount }}'
    };
  }

  function passend(eintrag, bezug) {
    if (!eintrag || !eintrag.handle || eintrag.handle === bezug.handle) return false;
    if (eintrag.available !== true) return false;
    var index = zahl(eintrag.index);
    if (index === null || index <= 0) return false;
    if (zahl(eintrag.price) === null) return false;
    if (schluessel(eintrag.width) !== bezug.breite) return false;
    if (schluessel(eintrag.aspect) !== bezug.quer) return false;
    if (schluessel(eintrag.rim) !== bezug.zoll) return false;
    if (saisonCode(eintrag.season) !== bezug.saison) return false;
    if (schluessel(eintrag.load) !== bezug.last) return false;
    if (text(eintrag.speed).toUpperCase() !== bezug.tempo) return false;
    return true;
  }

  function rolleNachFakten(e, bezug, texte) {
    var guenstiger = bezug.preis !== null && e.preis < bezug.preis;
    var besser = bezug.index !== null && e.index > bezug.index;
    if (guenstiger && besser) return { text: texte.rolleBeide, gut: true };
    if (guenstiger) return { text: texte.rolleGuenstiger, gut: false };
    if (besser) return { text: texte.rolleBesser, gut: false };
    return { text: texte.rolleGleich, gut: false };
  }

  function ordnen(pool, bezug, texte) {
    var nachIndex = pool.slice().sort(function (a, b) {
      return b.index - a.index || a.preis - b.preis;
    });
    var nachPreis = pool.slice().sort(function (a, b) {
      return a.preis - b.preis || b.index - a.index;
    });
    var gewaehlt = [];

    function nimm(e, rolle, gut) {
      if (!e || gewaehlt.indexOf(e) !== -1) return;
      e.rolle = { text: rolle, gut: gut };
      gewaehlt.push(e);
    }

    if (bezug.index !== null && bezug.preis !== null) {
      nimm(nachIndex.filter(function (e) {
        return e.preis < bezug.preis && e.index > bezug.index;
      })[0], texte.rolleBeide, true);
    }
    if (nachIndex[0] && (bezug.index === null || nachIndex[0].index > bezug.index)) {
      nimm(nachIndex[0], texte.rolleBester, false);
    }
    if (nachPreis[0] && bezug.preis !== null && nachPreis[0].preis < bezug.preis) {
      nimm(nachPreis[0], texte.rolleGuenstigster, false);
    }

    var uebrige = nachIndex.filter(function (e) {
      return gewaehlt.indexOf(e) === -1;
    });
    uebrige.forEach(function (e) {
      e.rolle = rolleNachFakten(e, bezug, texte);
    });

    // Vorne die Karten mit eigener Rolle, dann nach Index aufgefüllt.
    return gewaehlt.concat(uebrige);
  }

  function karte(e, bezug, texte, klasse) {
    var li = element('li', 'vqalt__karte' + (klasse ? ' ' + klasse : ''));
    var link = element('a', 'vqalt__link');
    link.href = e.url;

    var rolle = element('span', 'vqalt__rolle' + (e.rolle.gut ? ' vqalt__rolle--gut' : ''), e.rolle.text);
    link.appendChild(rolle);

    var band = element('span', 'vqalt__band');
    var kopf = element('span', 'vqalt__band-kopf');
    if (text(e.logo)) {
      // Kommt fertig aus snippets/tire-marken-logo.liquid, also aus dem eigenen Theme.
      var logo = element('span', 'vqalt__band-logo');
      logo.innerHTML = e.logo;
      kopf.appendChild(logo);
    } else {
      kopf.appendChild(element('span', 'vqalt__marke-text', e.vendor));
    }
    if (text(e.segment)) {
      kopf.appendChild(element('span', 'vqalt__pille vqalt__pille--' + e.segment, e.segmentText));
    }
    band.appendChild(kopf);
    if (e.image) {
      var bild = element('img', 'vqalt__reifen');
      bild.src = e.image;
      bild.alt = '';
      bild.width = 400;
      bild.height = 400;
      bild.loading = 'lazy';
      bild.decoding = 'async';
      band.appendChild(bild);
    }
    link.appendChild(band);

    var leib = element('span', 'vqalt__leib');
    leib.appendChild(element('span', 'vqalt__name', modellName(e)));
    leib.appendChild(element('span', 'vqalt__aus', kennungVon(e)));

    var werte = element('span', 'vqalt__werte');

    var wIndex = element('span', 'vqalt__wert');
    wIndex.appendChild(element('small', '', texte.index));
    wIndex.appendChild(element('b', '', String(e.index)));
    if (bezug.index !== null) {
      var di = e.index - bezug.index;
      wIndex.appendChild(element('span', 'vqalt__delta' + (di > 0 ? ' vqalt__delta--blau' : ''), differenz(di, String(Math.abs(di)))));
    }
    werte.appendChild(wIndex);

    var wPreis = element('span', 'vqalt__wert');
    wPreis.appendChild(element('small', '', texte.proReifen));
    wPreis.appendChild(element('b', '', betrag(e.preis)));
    if (bezug.preis !== null) {
      var dp = e.preis - bezug.preis;
      wPreis.appendChild(element('span', 'vqalt__delta' + (dp < 0 ? ' vqalt__delta--gut' : ''), differenz(dp, betrag(dp))));
    }
    werte.appendChild(wPreis);

    leib.appendChild(werte);
    link.appendChild(leib);
    li.appendChild(link);
    return li;
  }

  function spannenText(liste, bezug, texte) {
    if (!liste.length) return '';
    var preise = liste.map(function (e) { return e.preis; });
    var indizes = liste.map(function (e) { return e.index; });
    return texte.spanne
      .replace('[preis_min]', geld(bezug.geldformat, Math.min.apply(null, preise)))
      .replace('[preis_max]', geld(bezug.geldformat, Math.max.apply(null, preise)))
      .replace('[index_min]', String(Math.min.apply(null, indizes)))
      .replace('[index_max]', String(Math.max.apply(null, indizes)));
  }

  function mehrText(anzahl, texte) {
    var muster = anzahl === 1 ? texte.mehrEins : texte.mehrViele;
    return muster.replace('[anzahl]', String(anzahl)).replace('[kennung]', texte.kennung);
  }

  function kachel(restBreit, restSchmal, bezug, texte) {
    var li = element('li', 'vqalt__mehr-eintrag' + (restBreit.length ? '' : ' vqalt__mehr-eintrag--nur-schmal'));
    var knopf = element('button', 'vqalt__mehr');
    knopf.type = 'button';
    knopf.setAttribute('aria-expanded', 'false');

    [['vqalt__mehr-breit', restBreit], ['vqalt__mehr-schmal', restSchmal]].forEach(function (paar) {
      if (!paar[1].length) return;
      var huelle = element('span', paar[0]);
      var titel = element('b', '', mehrText(paar[1].length, texte) + ' ');
      titel.appendChild(element('span', '', '→')).setAttribute('aria-hidden', 'true');
      huelle.appendChild(titel);
      huelle.appendChild(element('span', 'vqalt__mehr-spanne', spannenText(paar[1], bezug, texte)));
      knopf.appendChild(huelle);
    });

    li.appendChild(knopf);
    return li;
  }

  function aufbauen(wurzel, produkte) {
    var texteEl = wurzel.querySelector('[data-vqalt-texte]');
    var liste = wurzel.querySelector('[data-vqalt-karten]');
    if (!texteEl || !liste) return;

    var texte = JSON.parse(texteEl.textContent);
    var bezug = bezugLesen(wurzel);

    var gesehen = {};
    var pool = [];
    produkte.forEach(function (p) {
      if (gesehen[p.handle] || !passend(p, bezug)) return;
      gesehen[p.handle] = true;
      p.index = zahl(p.index);
      p.preis = zahl(p.price);
      pool.push(p);
    });
    if (!pool.length) return;

    var geordnet = ordnen(pool, bezug, texte);
    var restBreit = geordnet.slice(SICHTBAR_BREIT);
    var restSchmal = geordnet.slice(SICHTBAR_SCHMAL);

    geordnet.forEach(function (e, i) {
      var klasse = '';
      if (i >= SICHTBAR_BREIT) klasse = 'vqalt__karte--rest';
      else if (i >= SICHTBAR_SCHMAL) klasse = 'vqalt__karte--nur-breit';
      liste.appendChild(karte(e, bezug, texte, klasse));
    });

    if (restSchmal.length) {
      var mehr = kachel(restBreit, restSchmal, bezug, texte);
      liste.appendChild(mehr);
      mehr.querySelector('button').addEventListener('click', function (ereignis) {
        var knopf = ereignis.currentTarget;
        var schmal = window.matchMedia('(max-width: 749px)').matches;
        wurzel.classList.add('vqalt--offen');
        knopf.setAttribute('aria-expanded', 'true');
        var erste = liste.querySelector(schmal ? '.vqalt__karte--nur-breit .vqalt__link, .vqalt__karte--rest .vqalt__link' : '.vqalt__karte--rest .vqalt__link');
        if (erste) erste.focus();
      });
    }

    wurzel.hidden = false;
  }

  function start(wurzel) {
    if (wurzel.dataset.vqaltBereit === 'true') return;
    wurzel.dataset.vqaltBereit = 'true';
    var bezug = bezugLesen(wurzel);
    if (!bezug.abfrage) return;

    laden(bezug.wurzel, bezug.abfrage)
      .then(function (produkte) {
        aufbauen(wurzel, produkte);
      })
      .catch(function (fehler) {
        // Ohne Daten bleibt der Block verborgen; die Seite funktioniert weiter.
        if (window.console) console.warn('VANTIQ Alternativen:', fehler);
      });
  }

  // Geladen wird, sobald der Browser nach dem Seitenaufbau Luft hat — nicht
  // erst beim Scrollen. Ein Nachladen über IntersectionObserver liess sich am
  // 16.09.2026 in keiner der drei Prüfumgebungen auslösen (Headless-Chrome,
  // DevTools-Sitzung, verborgener Vorschaubereich), und ein Auslöser, den
  // niemand prüfen kann, darf nicht entscheiden, ob der Block erscheint. Der
  // Abruf ist klein: 78 Reifen in 225/40 R18 sind rund 55 KB vor der Kompression.
  function starten() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vqalt]'), start);
  }

  function nachDemLaden() {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(starten, { timeout: 2000 });
    } else {
      window.setTimeout(starten, 300);
    }
  }

  if (document.readyState === 'complete') {
    nachDemLaden();
  } else {
    window.addEventListener('load', nachDemLaden, { once: true });
  }
})();
